(() => {
    class PreviewModalController {
        constructor(
            $scope,
            $state,
            $sce,
            $uibModalInstance,
            content,
            brandClass
        ) {
            $scope.content = $sce.trustAsHtml(content)
            $scope.brandClass = brandClass
            $scope.close = function () {
                $uibModalInstance.close()
            }
        }
    }

    angular
        .module('dashboard')
        .controller('wizardPreviewModal', [
            '$scope',
            '$state',
            '$sce',
            '$uibModalInstance',
            'content',
            'brandClass',
            PreviewModalController ]);

})();
